function initFaqNav() {
	const links = document.querySelectorAll('[data-faq-link]');
	const sections = document.querySelectorAll('[data-faq-section]');

	if (!links.length || !sections.length) return;

	function setActive(id) {
		links.forEach(link => link.classList.toggle('active', link.dataset.faqLink === id));
	}

	links.forEach(link => link.addEventListener('click', function (e) {
		e.preventDefault();

		const target = document.querySelector(`[data-faq-section="${this.dataset.faqLink}"]`);
		if (!target) return;

		setActive(this.dataset.faqLink);

		window.scrollTo({
			top: target.getBoundingClientRect().top + window.pageYOffset - (window.innerWidth <= 1199 ? 80 : 100),
			behavior: 'smooth'
		});
	}));

	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => entry.isIntersecting && setActive(entry.target.dataset.faqSection));
	}, { rootMargin: '-40% 0px -55% 0px', threshold: 0 });

	sections.forEach(section => observer.observe(section));
}

window.onload = () => {
	initFaqNav();
}